/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Professional role. The enum lists the 15 system values; an organisation may define additional employees.role custom enum values, which API responses can also carry.
 */
export enum models_ProfessionalRole {
    ProfessionalRoleIntern = 'INTERN',
    ProfessionalRolePedagogicAssistent = 'PEDAGOGIC_ASSISTENT',
    ProfessionalRoleApprentice = 'APPRENTICE',
    ProfessionalRoleApprenticeShort = 'APPRENTICE_SHORT',
    ProfessionalRoleEducator = 'EDUCATOR',
    ProfessionalRoleGroupHead = 'GROUP_HEAD',
    ProfessionalRoleMainGroupHead = 'MAIN_GROUP_HEAD',
    ProfessionalRoleDaycareCenterHead = 'DAYCARE_CENTER_HEAD',
    ProfessionalRoleCleaningStaff = 'CLEANING_STAFF',
    ProfessionalRoleJanitor = 'JANITOR',
    ProfessionalRoleChef = 'CHEF',
    ProfessionalRoleGoverness = 'GOVERNESS',
    ProfessionalRoleManagingDirector = 'MANAGING_DIRECTOR',
    ProfessionalRoleConsultant = 'CONSULTANT',
    ProfessionalRoleOther = 'OTHER',
}
